import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';

// The component is created to be used only via UserAlertService @shared/services/user-alert.service.ts

export type UserAlertDialogData = {
	title?: string, 
	message: string; 
	error: boolean 
}

@Component({
	selector: 'cass-user-alert-dialog',
	templateUrl: './user-alert-dialog.component.html',
	styleUrls: ['./user-alert-dialog.component.css']
})
export class UserAlertDialogComponent implements OnInit  {

	// TODO refactor this into the Dialog component

	// Use data.XYZ in the template
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: UserAlertDialogData,
		private http: HttpClient
	) { }

	ngOnInit(): void {
		this.getBranding();
	}

	public brandingErrorDialogContent?: string;

	private getBranding(): void {
		if (this.data.error) {
			this.http.get('./branding/html/alert-dialog-error.html', { responseType: 'text' })
				.toPromise()
				.then(value => this.brandingErrorDialogContent = value);
		}
	}

}
